import React from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from 'state/ducks/routes';
import { localized } from 'state/i18n';
import BiButton from 'view/shared/components/buttons/bi-button/bi-button';
import ResponsiveSpacingWrapper from 'view/shared/components/responsive-wrappers/responsive-spacing-wrapper';

import { IUnitDetailsDto } from 'api/api';
import { IdDataTuple } from 'utilities/types-util';
import TechnicalDetails from './cards/technical-details';
import { LocationCard } from './cards/location-card';
import MachineOwnerLocation from './cards/machine-owner-location';
import { ManualItem } from './documents-helper';

export interface Props {
	machineId: string;
	urlId: string;
	currMachine: IdDataTuple<IUnitDetailsDto, string>;
	latitude?: string;
	longitude?: string;
	isAdmin: boolean;
	isCountryAdmin: boolean;
	isSuperAdmin: boolean;
	isServiceTechnician: boolean;
	manualItems: ManualItem[];

	// Event Handlers
	onDeletePressed: () => void;
	onVideoBtnPressed: (videoName: string) => void;
}

export const BleDetailsContent: React.FC<Props> = ({
	machineId,
	urlId,
	currMachine,
	latitude,
	longitude,
	isAdmin,
	isCountryAdmin,
	isSuperAdmin,
	isServiceTechnician,
	manualItems,
	onDeletePressed,
	onVideoBtnPressed,
}) => {
	const cardAndBalerRow = (
		<div className="flex-direction-row margin-top-40 flex-space-between-row">
			<div className="flex-direction-column flex-fill-remaining-space">
				<div className="flex-direction-row flex-center-column margin-bottom-40">
					<h1 className="text-bold margin-bottom-0">{localized('MachineDetails')}</h1>
					<NavLink
						className="margin-left-5px margin-right-5px"
						to={`${Routes.UnitHistory}/${encodeURIComponent(urlId)}`}
					>
						<BiButton colorTheme="org-dark-blue-with-grey-text">{localized('UnitHistory')}</BiButton>
					</NavLink>
					{currMachine.data.ownerGroupId && isCountryAdmin && (
						<div className="margin-left-5px margin-right-5px">
							<BiButton colorTheme="org-red" onClick={onDeletePressed}>
								{localized('DeleteMachine')}
							</BiButton>
						</div>
					)}
				</div>
			</div>
		</div>
	);

	const { id } = currMachine.data;

	return (
		<ResponsiveSpacingWrapper>
			{cardAndBalerRow}

			<div className="flex-direction-row flex-wrap-responsive">
				<TechnicalDetails
					isAdmin={isAdmin}
					isCountryAdmin={isCountryAdmin}
					machineDetailsId={machineId}
					handleVideoBtnPressed={onVideoBtnPressed}
					manualItems={manualItems}
				/>
				<MachineOwnerLocation
					isAdmin={isAdmin}
					isSuperAdmin={isSuperAdmin}
					isCountryAdmin={isCountryAdmin}
					isServiceTechnician={isServiceTechnician}
					machineDetailsId={machineId}
					id={id}
				/>
				<LocationCard currMachine={currMachine} latitude={latitude} longitude={longitude} />
			</div>
		</ResponsiveSpacingWrapper>
	);
};
